<template>
  <div>
    <div class="divide-y">
      <div
        v-for="(daily, index) in dailydaily.data"
        :key="index"
        class="flex flex-col p-4 md:flex-row"
      >
        <div class="md:w-1/4">
          <div class="">
            <h1 class="text-3xl font-bold text-default-500">{{ daily.day }}</h1>
            <h3 class="text-lg">{{ daily.day_week }}</h3>
            <small>{{ daily.month }} de {{ daily.year }}</small>
          </div>
        </div>
        <div class="divide-y md:w-3/4">
          <div
            class="py-2"
            :class="{ 'border-top': index !== 0 }"
            v-for="(agenda, index) in daily.data"
            :key="index"
          >
            <a
              :href="agenda.links.url"
              class="text-default-500 hover:text-default-600"
            >
              <h5 class="font-semibold">
                {{ agenda.title }}
              </h5>
            </a>
            <div>
              <small class="card-text">
                <strong>Local: </strong> {{ agenda.place }}
              </small>
            </div>
            <div>
              <small class="card-text">
                <strong>Período:</strong> {{ agenda.period }} -
                <strong>Horario:</strong> {{ agenda.time_start }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <paginate
        class="mt-3"
        v-if="dailydaily.data"
        :meta="dailydaily.meta"
        :links="dailydaily.links"
        event="listagenda"
        @listagenda="getdaily"
      />
    </div>
    <div v-show="loading" class="text-center">Carregando...</div>
  </div>
</template>

<script>
import Semed from "./../../api/Semed";
import Paginate from "./../global/Paginate.vue";

export default {
  name: "ListDailyAgenda",

  components: { Paginate },
  props: ["link"],
  data() {
    return {
      dailydaily: {},
      loading: true,
    };
  },
  created() {
    this.getdaily(this.link);
  },
  methods: {
    getdaily(link) {
      this.loading = true;
      Semed.get(link).then((response) => {
        this.dailydaily = response;
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped></style>
